
export class EncryptionValues {
    static readonly NEW_RSA_KEY_LENGTH = 60; // 60 bytes
}